<template>
    <div class="mobile-footer bg-primary text-light">
        <b-container fluid>
            <div class="mobile-footer__content">
                <div class="mobile-footer__content__info">
                    <div class="mobile-footer__content__info__total">
                        <div class="mobile-footer__content__info__total__title">
                            Amount Due:&nbsp;
                        </div>
                        <div class="mobile-footer__content__info__total__sum">
                            {{
                                !!client.guest_credit_amount
                                    ? guestCreditBalance
                                    : scheduleDepositSumAmount
                            }}
                        </div>
                    </div>
                    <div 
                        class="mobile-footer__content__info__dates" 
                        v-if="formattedDates"
                    >
                        {{ formattedDates.fromDate }} - {{ formattedDates.toDate }}
                    </div>
                </div>
                <div class="mobile-footer__content__button">
                    <b-button
                        size="md"
                        type="button"
                        variant="light"
                        :disabled="busy || rentalAgreementBusy"
                        @click="$emit('open')"
                    >
                        Review Booking
                    </b-button>
                </div>
            </div>
        </b-container>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO'; 
import { toAmountDisplay } from '../../../../utils/numbers';
import { calculateTotal } from '../common/utils';

export default {
    computed: {
        ...mapGetters('onlineBooking', ['busy', 'client', 'reservation', 'rentalAgreementBusy']),
        guestCreditBalance() {
            const total = calculateTotal({ reservation: this.reservation, client: this.client });
            return toAmountDisplay({
                amount: total,
                currency: this.reservation.currency.symbol,
            });
        },
        scheduleDepositSumAmount() {
            return toAmountDisplay({
                amount: this.reservation.schedule.deposit.sum,
                currency: this.reservation.currency.symbol,
            });
        },
        formattedDates() {
            return {
                fromDate: format(
                    parseISO(this.reservation.tech_reservations[0].tech_reservation.from_date),
                    'dd MMM'
                ),
                toDate: format(
                    parseISO(this.reservation.tech_reservations[0].tech_reservation.to_date),
                    'dd MMM'
                ),
            }
        },
    }
}
</script>

<style lang="scss" scoped>
    .mobile-footer {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        border-top: 1px solid rgb(221, 221, 221);
        z-index: 100;
        background-color: #fff;

        &__content {
            padding: 16px 0;
            display: flex;
            justify-content: space-between;
            align-items: center;
            &__info {
                display: flex;
                flex-direction: column;
                &__total {
                    display: flex;
                    align-items: center;
                    &__sum {
                        font-size: 16px;
                        font-weight: bold;
                        text-decoration: underline;
                    }

                    &__title {
                        font-size: 14px;
                    }
                }
                &__dates {
                    font-size: 14px;
                    text-decoration: underline;
                }
            }   
        }
    }
</style>
